module.exports = __webpack_public_path__ + "static/water_glacier13-044232eabf0bf5ff76291c99761aac1c.jpg";